module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/equipment03-38f3d008f891d72bbdd5225b6725a9a0.png";